import { useRouteMatch } from 'react-router-dom';
import { JobUIStatusEnum } from 'domains/workspaceDomain';

export const useRouteMatchFilter = () => {
  return useRouteMatch().params as { defaultFilter: JobUIStatusEnum };
};
